import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

import { LoggerService } from '../services/common/logger.service';
import { NotyService } from '../services/common/noty.service';
import { UserService } from '../services/users/user.service';

@Injectable()
export class IntranetGuard {
  /**
   * Constructor
   * @param {LoggerService} private loggerService Logger service to log only for development environment
   * @param {NotyService}   private notyService   Service to show notifications in web UI
   * @param {UserService}   private userService   Service to access users controller
   */
  constructor(private loggerService: LoggerService, private notyService: NotyService, private userService: UserService) {}

  /**
   * Function to authenticate a route for current user
   * @param  {ActivatedRouteSnapshot} next  Next route data
   * @param  {RouterStateSnapshot}    state Router state
   * @return {Observable<boolean>}          Returns boolean indicating if user is allowed to access route, resultant value maybe a boolean or an observable returning a boolean value
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.loggerService.devLog(['Intranet Guard - Route Data', next.data]);
    console.log("next: ActivatedRouteSnapshot", next);
    console.log("state: RouterStateSnapshot", state);
    if (next.data && next.data.intranet_resource) {
      return this.userService.resourcePermission(next.data.intranet_resource, next.params.id, next.data.action || '', next.data.guard_name).then((response_json) => {
        console.log("user service resourcePermission response", response_json);
        if (response_json.success) {
          return true;
        } else {
          this.notyService.notify(response_json.text || `Error accessing ${next.data.guard_name}`, 'error');
          return false;
        }
      });
    } else return false;
  }
}
